var _circle, _path, _g, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#EAF2FF",
    stroke: "url(#paint0_linear_623_69)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 54.1107C81 58.3223 77.3397 61.6154 73.1162 61.2036L46.066 58.5656C42.3895 58.207 39.5869 55.1389 39.5869 51.4727L39.5869 38.0994C39.5869 34.4019 42.4362 31.3184 46.148 30.999L73.1982 28.6714C77.3935 28.3104 81 31.5927 81 35.7718L81 54.1107Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_623_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 44.8894C19 40.6778 22.6603 37.3846 26.8838 37.7965L53.934 40.4345C57.6105 40.793 60.4131 43.8611 60.4131 47.5274V60.9006C60.4131 64.5982 57.5638 67.6817 53.852 68.0011L26.8018 70.3287C22.6066 70.6897 19 67.4074 19 63.2283V44.8894Z",
    fill: "url(#paint1_linear_623_69)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 44.8894C19 40.6778 22.6603 37.3846 26.8838 37.7965L53.934 40.4345C57.6105 40.793 60.4131 43.8611 60.4131 47.5274V60.9006C60.4131 64.5982 57.5638 67.6817 53.852 68.0011L26.8018 70.3287C22.6066 70.6897 19 67.4074 19 63.2283V44.8894Z",
    stroke: "url(#paint2_linear_623_69)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_623_69)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9223 40.5527L26.8721 37.9147C22.719 37.5097 19.1197 40.7479 19.1197 44.8894V63.2283C19.1197 67.3377 22.6661 70.5653 26.7915 70.2104L53.8417 67.8827C57.4916 67.5687 60.2934 64.5366 60.2934 60.9006V47.5274C60.2934 43.9223 57.5375 40.9052 53.9223 40.5527ZM26.8838 37.7965C22.6603 37.3846 19 40.6778 19 44.8894V63.2283C19 67.4074 22.6066 70.6897 26.8018 70.3287L53.852 68.0011C57.5638 67.6817 60.4131 64.5982 60.4131 60.9006V47.5274C60.4131 43.8611 57.6105 40.793 53.934 40.4345L26.8838 37.7965Z",
    fill: "url(#paint3_linear_623_69)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9223 40.5527L26.8721 37.9147C22.719 37.5097 19.1197 40.7479 19.1197 44.8894V63.2283C19.1197 67.3377 22.6661 70.5653 26.7915 70.2104L53.8417 67.8827C57.4916 67.5687 60.2934 64.5366 60.2934 60.9006V47.5274C60.2934 43.9223 57.5375 40.9052 53.9223 40.5527ZM26.8838 37.7965C22.6603 37.3846 19 40.6778 19 44.8894V63.2283C19 67.4074 22.6066 70.6897 26.8018 70.3287L53.852 68.0011C57.5638 67.6817 60.4131 64.5982 60.4131 60.9006V47.5274C60.4131 43.8611 57.6105 40.793 53.934 40.4345L26.8838 37.7965Z",
    fill: "url(#paint4_radial_623_69)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3 57.25H39C39 56.6667 39.1333 56.0917 39.4 55.525C39.6833 54.9417 40.0167 54.425 40.4 53.975C40.7833 53.525 41.1667 53.1 41.55 52.7C41.9333 52.2833 42.2583 51.875 42.525 51.475C42.8083 51.0583 42.95 50.675 42.95 50.325C42.95 49.075 42 48.45 40.1 48.45C38.7 48.45 37.2917 48.8583 35.875 49.675V46.375C37.3917 45.5583 39.0083 45.15 40.725 45.15C42.4583 45.15 43.8833 45.5083 45 46.225C46.1333 46.9417 46.7 48.0417 46.7 49.525C46.7 50.1583 46.55 50.7917 46.25 51.425C45.95 52.0417 45.5833 52.6 45.15 53.1C44.7167 53.5833 44.2833 54.0583 43.85 54.525C43.4167 54.975 43.05 55.4417 42.75 55.925C42.45 56.3917 42.3 56.8333 42.3 57.25ZM42.175 59.75C42.575 60.1 42.775 60.6083 42.775 61.275C42.775 61.9417 42.575 62.45 42.175 62.8C41.775 63.15 41.275 63.325 40.675 63.325C40.075 63.325 39.5667 63.15 39.15 62.8C38.75 62.45 38.55 61.9417 38.55 61.275C38.55 60.6083 38.75 60.1 39.15 59.75C39.5667 59.4 40.075 59.225 40.675 59.225C41.275 59.225 41.775 59.4 42.175 59.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_623_69",
    x: 16.85,
    y: 35.6117,
    width: 45.7131,
    height: 36.8942,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_623_69",
    x: -11,
    y: 7.76166,
    width: 101.413,
    height: 92.5942,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_69",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D0CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_69",
    x1: 23.4317,
    y1: 40.7689,
    x2: 62.9932,
    y2: 66.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#393184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_69",
    x1: 43.1577,
    y1: 43.194,
    x2: 53.3814,
    y2: 73.5038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_69",
    x1: 24.9598,
    y1: 36.5976,
    x2: 58.5339,
    y2: 61.5042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_623_69",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.189 69.2888) rotate(-44.1611) scale(28.5445 47.6877)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionGlassIcon);
export default __webpack_public_path__ + "static/media/question-glass-icon.d5a87c72fbb8e2c118a4d95db03314df.svg";
export { ForwardRef as ReactComponent };